<template>
  <div ref="mySearchBar">
    <div class="input-only-icon-search" @click="clickopeninmovilsearch" v-if="viewiconbtn">
      <img class="imgonlyiconsearc" src="https://golstatsimages.blob.core.windows.net/todoelfut/search-svg.svg" />
    </div>
    <div
      v-if="!viewinput"
      class="search-component"
      :class="
        inputinfocus
          ? view == 1
            ? 'tablet-search-component'
            : view == 2
            ? 'movil-search-component'
            : 'pc-search-component'
          : ''
      "
    >
      <div
        class="search-box"
        :class="
          inputinfocus ? (view == 1 ? 'tablet-search-box' : view == 2 ? 'movil-search-box' : 'pc-search-box') : ''
        "
      >
        <img class="searchiconimg" src="https://golstatsimages.blob.core.windows.net/todoelfut/search-svg.svg" />
        <input
          style="vertical-align: 4px; width: 255px;"
          name="focus"
          type="text"
          :key="update"
          ref="myInput"
          @input="onInputMobile"
          v-model="inputValue"
          @click="focusOnInput"
          @blur="handleBlur"
          autocomplete="off"
          placeholder="Ingresa una búsqueda"
          id="search-input"
          value=""
          :class="
            inputinfocus
              ? view == 1
                ? 'tablet-search-input'
                : view == 2
                ? 'movil-search-input'
                : 'pc-search-input'
              : ''
          "
        />
      </div>
      <div class="container-search-result" v-if="inputinfocus && Object.keys(dataSearchPrintObject).length > 0">
        <div class="container-search-result__cont-result" v-if="Object.keys(dataSearchPrintObject).length > 0">
          <div
            class="cont-noresult"
            v-if="
              Object.keys(dataSearchPrintObject.players).length == 0 &&
                Object.keys(dataSearchPrintObject.teams).length == 0
            "
          >
            <img
              class="cont-noresult__imgnoresult"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/graf_busqueda@2x.png"
              width="74"
            />
            <div class="cont-noresult__titlenoresult">Sin resultados</div>
            <div class="cont-noresult__subnoresult">
              No se encontraron resultados que<br />
              coincidan con la búsqueda.
            </div>
          </div>
          <div
            class="container-search-result__cont-result__cont-type"
            v-if="Object.keys(dataSearchPrintObject.teams).length > 0"
          >
            <div class="container-search-result__cont-result__cont-type__header">EQUIPOS</div>
            <template v-for="team in dataSearchPrintObject.teams">
              <div
                :key="team.team_id"
                class="container-search-result__cont-result__cont-type__item"
                @click="openProfile(2, team.team_id, team.season_id, team.tournament_id)"
              >
                <div class="container-search-result__cont-result__cont-type__item__photo">
                  <img :src="team.logo" />
                </div>
                <div class="container-search-result__cont-result__cont-type__item__name">{{ team.team_name }}</div>
                <div class="container-search-result__cont-result__cont-type__item__league">
                  <template v-if="team.tournament_id != 33"
                    ><img :src="'https://golstatsimages.blob.core.windows.net/todoelfut/' + team.tournament_id + '.png'"
                  /></template>
                  <template v-else>
                    <img
                      :src="
                        simageExists('https://golstatsimages.blob.core.windows.net/todoelfut/' + team.season_id + '.png')
                          ? 'https://golstatsimages.blob.core.windows.net/todoelfut/' + team.season_id + '.png'
                          : 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_internacionales.png'
                      "
                    />
                  </template>
                </div>
              </div>
            </template>
          </div>
          <div
            class="container-search-result__cont-result__cont-type"
            v-if="Object.keys(dataSearchPrintObject.players).length > 0"
          >
            <div class="container-search-result__cont-result__cont-type__header">JUGADORES</div>
            <template v-for="player in dataSearchPrintObject.players">
              <div
                :key="player.player_id"
                class="container-search-result__cont-result__cont-type__item"
                @click="openProfile(1, player.player_id, player.season_id, player.tournament_id)"
              >
                <div class="container-search-result__cont-result__cont-type__item__photo-player">
                  <img :src="player.photo" :alt="player.player_name" />
                </div>
                <div class="container-search-result__cont-result__cont-type__item__name">
                  {{ player.player_name }}
                </div>
                <div class="container-search-result__cont-result__cont-type__item__league">
                  <img :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + player.team_id + '.png'" />
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="container-search-result__close-container">
          <div class="container-search-result__close-container__btn" @click="clickclosesearch">
            Cerrar X
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';
import axios from 'axios';
import EventBus from '@/utils/event-bus';
export default {
  name: 'SearchComponent',
  props: {
    view: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeEventTablet: false,
      inputinfocus: false,
      openSearch: false,
      inputValue: '',
      searchResult: {},
      isComposing: true,
      searchResultFinal: {},
      update: 0,
      url: 'https://qarrn3ar0f.execute-api.us-east-2.amazonaws.com/prod/search',
    };
  },
  created() {
    this.debouncedInputValue = debounce(() => {
      this.checkInputValue();
    }, 500);
    EventBus.$on('click-close-login', this.clickCloseLogin);
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleWindowResize);
    setTimeout(() => {
      if (this.type == 1) this.getInfoSearch();
    }, 1600);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.handleWindowResize);
  },
  computed: {
    ...mapGetters('loginGeneral', ['getTournaments', 'getSeasons', 'getSeasonSelected']),
    dataSearchPrint: function() {
      let newLen = this.searchResult;
      return newLen;
    },
    dataSearchPrintObject: function() {
      let newLen = this.searchResultFinal;
      return newLen;
    },
    viewiconbtn() {
      return this.view == 2;
    },
    viewinput() {
      if (this.openSearch) {
        return false;
      } else {
        return this.view == 2 && !this.inputinfocus;
      }
    },
  },
  watch: {
    inputValue() {
      this.debouncedInputValue();
    },
    view: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$emit('numview', newValue);
          if (newValue == 0) {
            // this.$emit('inputinfocus', false);
            // this.inputinfocus = false;
            // this.openSearch = false;
          }
        }
      },
    },
  },
  methods: {
    // onCompositionStart() {
    //   // This method will be called when composition starts
    //   // on a mobile device (e.g. when user is still typing)
    //   this.isComposing = true;
    // },
    // onCompositionEnd() {
    //   // This method will be called when composition ends
    //   // on a mobile device (e.g. when user finishes typing)
    //   this.isComposing = false;
    //   // Trigger input event manually to capture the latest input value
    //   this.onInputMobile();
    // },
    ...mapActions('loginGeneral', [
      'storeTournamentSelected',
      'storeSeasonSelected',
      'storeTournamentNameSelected',
      'storeSeasonNameSelected',
    ]),
    clickCloseLogin() {
      this.update += 1;
      this.inputValue = '';
    },
    simageExists(image_url) {
      var http = new XMLHttpRequest();

      http.open('HEAD', image_url, false);
      http.send();

      return http.status != 404;
    },
    openProfile(type, id, season, tournament) {
      this.storeTournamentSelected(tournament);
      this.storeTournamentNameSelected(this.getTournaments[tournament].name);
      this.storeSeasonNameSelected(this.getSeasons[tournament][Object.keys(this.getSeasons[tournament])[0]].name);

      if (this.getSeasons[tournament][' ' + season]) {
        if (type === 2) {
          this.storeSeasonSelected(this.getSeasons[tournament][' ' + season].id);
        } else {
          this.storeSeasonSelected(Object.keys(this.getSeasons[tournament])[0].slice(1));
        }
      } else {
        this.storeSeasonSelected(Object.keys(this.getSeasons[tournament])[0].slice(1));
      }

      let route = {};
      if (type === 1) {
        route = { name: 'player', params: { seasonId: season, playerId: id } };
      } else {
        route = { name: 'team', params: { teamId: id } };
      }
      setTimeout(() => {
        this.$emit('numview', this.view);
        this.$emit('inputinfocus', false);
        this.inputinfocus = false;
        this.openSearch = false;
        this.inputValue = '';
        this.searchResult = {};
        this.searchResultFinal = {};
      }, 500);

      this.$router.push(route);
    },
    checkInputValue() {
      if (this.inputValue.length >= 3) {
        const objDataSearch = JSON.parse(localStorage.getItem('data-search'));
        let sanitizedSearch = this.sanitizeInput(this.inputValue);
        let resultPlayers = objDataSearch.players.filter(item =>
          this.sanitizeInput(item.player_name).includes(sanitizedSearch),
        );
        let resultTeams = objDataSearch.teams.filter(
          item =>
            this.sanitizeInput(item.team_name).includes(sanitizedSearch) ||
            this.sanitizeInput(item.colloquial_name).includes(sanitizedSearch),
        );
        this.searchResult.teams = resultTeams;
        this.searchResult.players = resultPlayers;
        this.searchResultFinal = JSON.parse(JSON.stringify(this.searchResult));
      } else {
        if (this.inputValue.length == 0) {
          this.$emit('numview', this.view);
          this.openSearch = false;
          this.inputValue = '';
          this.searchResult = {};
          this.searchResultFinal = {};
        }
      }
    },
    sanitizeInput(input) {
      if (input) {
        return input
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[ñ]/g, 'n')
          .normalize()
          .toLowerCase();
      } else {
        return '';
      }
    },
    onInputMobile(event) {
      this.inputValue = event.target.value;
      this.checkInputValue();
    },
    handleBlur() {},
    focusOnInput() {
      this.$emit('inputinfocus', true);
      this.inputinfocus = true;
      this.$emit('numview', this.view);
    },
    async getInfoSearch() {
      const datasearch = await axios
        .get(this.url)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getInfoSearch();
          }
          return e;
        });
      if (datasearch) {
        window.localStorage.setItem('data-search', JSON.stringify(datasearch.data));
      }
    },
    handleWindowResize() {
      if (this.$refs.myInput) {
        if (this.view != 2) {
          this.$emit('inputinfocus', false);
          this.inputinfocus = false;
          this.openSearch = false;
          this.inputValue = '';
          this.$emit('numview', this.view);
          this.searchResult = {};
          this.searchResultFinal = {};
        }
      }
    },
    handleClickOutside(event) {
      if (this.inputinfocus) {
        if (this.$refs.mySearchBar) {
          if (!this.$refs.mySearchBar.contains(event.target)) {
            this.$emit('numview', this.view);
            this.$emit('inputinfocus', false);
            this.inputinfocus = false;
            this.openSearch = false;
            this.inputValue = '';
            this.searchResult = {};
            this.searchResultFinal = {};
          }
        }
      }
    },
    clickclosesearch() {
      this.$emit('numview', this.view);
      this.$emit('inputinfocus', false);
      this.inputinfocus = false;
      this.openSearch = false;
      this.inputValue = '';
      this.searchResult = {};
      this.searchResultFinal = {};
    },
    clickopeninmovilsearch() {
      this.openSearch = true;
      this.$emit('inputinfocus', true);
      this.inputinfocus = true;
      this.$emit('numview', this.view);
      setTimeout(() => {
        const inputElement = this.$refs.myInput;
        inputElement.focus();
        inputElement.click();
        setTimeout(() => {
          if (/Mobi|Android|iOS/i.test(navigator.userAgent)) {
            const event = new Event('focus');
            inputElement.dispatchEvent(event);
          }
        }, 100);
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
.cont-noresult {
  width: 100%;
  height: 180px;
  &__imgnoresult {
    margin-top: 15px;
  }
  &__titlenoresult {
    width: 100%;
    margin-top: 14px;
    text-align: center;
    font-family: 'Circular-Std';
    font-size: 19px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    color: #354252;
    line-height: normal;
    letter-spacing: -0.52px;
  }
  &__subnoresult {
    width: 100%;
    text-align: center;
    margin-top: 4px;
    font-family: 'Circular-Std';
    font-size: 12px;
    line-height: 12px;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 0.12px;
    color: #b9b9b9;
  }
}
.container-search-result {
  width: 100%;
  height: auto;
  max-height: 400px;
  border-radius: 4px;

  position: absolute;
  // box-shadow: inset 0 -1px 0 0 rgba(183, 183, 184, 0.22);
  background-color: #fff;
  box-shadow: 0px 9px 12px 3px rgba(77, 76, 76, 0.75);
  -webkit-box-shadow: 0px 9px 12px 3px rgba(77, 76, 76, 0.75);
  -moz-box-shadow: 0px 9px 12px 3px rgba(77, 76, 76, 0.75);
  &__cont-result {
    width: 100%;
    height: auto;
    max-height: 374px;
    overflow-x: auto;
    &__cont-type {
      width: 100%;
      height: auto;
      background: blue;
      &__header {
        height: 25px;
        background-color: #f7f8f9;
        line-height: 25px;
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-family: 'Avenir-Demi';
        font-style: normal;
        letter-spacing: 0.44px;
        text-align: left;
        color: #6c7c8c;
        padding-left: 10px;
      }
      &__item {
        width: 100%;
        height: 40px;
        box-shadow: inset 0 -1px 0 0 rgba(183, 183, 184, 0.22);
        border: solid 1px rgba(255, 255, 255, 0.4);
        background-color: #fff;
        color: #111f2c !important;
        font-family: 'Avenir-Medium';
        &:hover {
          box-shadow: inset 0 -1px 0 0 rgba(183, 183, 184, 0.22);
          border: solid 1px rgba(255, 255, 255, 0.4);
          background-color: #359eff;
          cursor: pointer;
          color: white !important;
          font-family: 'Avenir-Bold';
        }
        &__photo {
          width: 15%;
          height: 40px;
          float: left;
          display: inline-flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
          }
        }
        &__photo-player {
          width: 15%;
          height: 40px;
          float: left;
          display: inline-flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          img {
            width: 18px;
            border-radius: 4px;
          }
        }
        &__name {
          float: left;
          width: 70%;
          height: 40px;
          font-size: 14px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;

          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          display: inline-flex;
          align-content: center;
          align-items: center;
          justify-content: left;
        }
        &__league {
          float: left;
          width: 15%;
          height: 40px;
          display: inline-flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          img {
            width: 24px;
          }
        }
      }
    }
  }
  &__close-container {
    width: 100%;
    height: 32px;
    background-color: #f7f8f9;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    &__btn {
      width: 100px;
      height: 32px;
      float: right;
      font-size: 11px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.52px;
      text-align: center;
      color: #727272;
      padding-right: 1px;
      line-height: 34px;
      font-family: 'Avenir-Medium';

      cursor: pointer;
      &:hover {
        color: #fff;
        background-color: #d4d4d4;
        border-bottom-right-radius: 6px;
      }
    }
  }
}
.input-only-icon-search {
  width: 27px;
  height: 43px;
  text-align: center;
  position: relative;
  // @media screen and (max-width: 380px) {
  //   margin-left: calc((100vw / 2) + 20px);
  // }
  // @media screen and (max-width: 370px) {
  //   margin-left: calc((100vw / 2) + 10px);
  // }
  // @media screen and (max-width: 350px) {
  //   margin-left: calc((100vw / 2) - 0px);
  // }
  // @media screen and (max-width: 330px) {
  //   margin-left: calc((100vw / 2) - 10px);
  // }
}
.imgonlyiconsearc {
  position: absolute;
  width: 27px;
  z-index: -1;
  margin-left: -14px;
  margin-top: 7px;
}
.tablet-search-input {
  min-width: calc(100vw - 115px) !important;
}
.tablet-search-component {
  min-width: calc(100vw - 115px) !important;
}
.tablet-search-box {
  min-width: calc(100vw - 115px) !important;
}

.movil-search-input {
  min-width: 100% !important;
  @media screen and (max-width: 350px) {
    width: 60% !important;
  }
}
.movil-search-component {
  min-width: 99% !important;
  left: 0px;
  margin-left: 0.5%;
  z-index: 2;
  background: #132739;
  top: 4px;
  position: absolute !important;
  @media screen and (max-width: 350px) {
    width: 60% !important;
  }
}
.movil-search-box {
  min-width: 100% !important;
  @media screen and (max-width: 350px) {
    width: 60% !important;
  }
}
.search-component {
  width: 340px;
  position: relative;
  // background: goldenrod;
  @media screen and (max-width: 768px) {
    width: 210px;
  }
}
.searchiconimg {
  position: absolute;
  width: 25px;
  margin-left: 5px;
  margin-top: 9px;
}
.search-box {
  height: 43px;
  border: solid 1px rgba(255, 255, 255, 0.4);
  width: 340px;
  @media screen and (max-width: 768px) {
    width: 210px;
  }
  transition: 0.2s;
  position: relative;
  border-radius: 6px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Avenir-Demi';
  line-height: 48px;
}
.search-box:hover {
  border: solid 1px rgba(255, 255, 255, 0.6);
}
.search-box:focus-within {
  border: solid 1px #0d4578;
  box-shadow: 0 0 0 1px rgba(12, 1, 110, 0.4);
  background-color: #0d4578;
  color: white !important;
}
.search-box input {
  background: transparent;
  letter-spacing: -0.2px;
  font-size: 30px;
  border: none;
  width: 100% !important;
  border-radius: 6px;
  height: 43px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Avenir-Demi';
  padding-left: 35px;
}
.search-box input:focus-within {
  color: white !important;
}
.search-box input:focus {
  outline: none;
}
.search-box input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
</style>
